import { render, staticRenderFns } from "./code-sheet.vue?vue&type=template&id=084e70ec&scoped=true&"
import script from "./code-sheet.vue?vue&type=script&lang=js&"
export * from "./code-sheet.vue?vue&type=script&lang=js&"
import style0 from "./code-sheet.vue?vue&type=style&index=0&id=084e70ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084e70ec",
  null
  
)

export default component.exports